import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=465ce9ff&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=ts"
export * from "./AlertBanner.vue?vue&type=script&lang=ts"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=465ce9ff&prod&lang=css"
import style1 from "./AlertBanner.vue?vue&type=style&index=1&id=465ce9ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ce9ff",
  null
  
)

export default component.exports